module.exports = __webpack_public_path__ + "static/media/b4.36924eb2.png";